module.exports = __webpack_public_path__ + "static/media/5.7574e870.jpg";